/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};
(function(){
    var f;
    f = new Class({
        //Extends: GS.BaseClass,
        Extends: GS.Filters.BaseFilter,
        class_name:'GS.Filters.ImpressionFilter',
        options:{
            'dx': 0,
            'hue':0,
            'staturation': 1,
            'lightness' : 0,
            'color_matrix':[],
            'brightness':0,
            'colorize':false,
            'shadow': {
                'display':0,
                'dx':3,
                'dy':3,
                'color': {'r':0,'g':0,'b':0,'a':1},
                'blur':1.5
            },
            'whitePointRGB' : {'r':255,'g':255,'b':255},
            'blackPointRGB' : {'r':0,'g':0,'b':0}
        },
        filter: {
            'id':0,
            'varnish' : false
        }
    });
    /*f.prototype.setup=function(paper){
        var svg;
        svg=paper.canvas;
        this.options.prefix = paper.canvas.getAttribute('id');
        this.filter.id = this.options.prefix + "_impression";
        if (!this.options.prefix) this.options.prefix = '';
        this.defs = svg.getElement('defs');
        if (!this.defs) this.defs = new Element('defs');
        if (!this.defs.querySelector('#' + this.filter.id)) {
            this.createFilter();
        }
    };*/

    f.prototype.applyTo=function(ele){
        this.ele = ele;
        if(this.options['impression']) {
            (ele.node || ele).setAttribute('filter', "url('#" + this.filter.id + "')");
        }
    };

    f.prototype.removeFrom=function(ele){
        (ele.node || ele).removeAttribute('filter',"url('#"+this.filter.id+"')");

    };
    /*
     *
     * @returns {undefined}
     */
    f.prototype.createFilter=function(){
        var f;
        //f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB', 'filterUnits': "objectBoundingBox"}),

        f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','filterUnits': "objectBoundingBox", 'x': "-10%",'y': "-10%",'width': "150%",'height': "150%"/*,'enable-background':'accumulate'*/});
        this.filter.container=f;
        this.addFilter();
        this.defs.adopt(f);
    };

    f.prototype.addFilter=function(){

        this.filter.container.innerHTML =  '\
        <feGaussianBlur in="SourceAlpha" stdDeviation="0.4" result="blur"/>\
        <feGaussianBlur in="SourceAlpha" stdDeviation="0.4" result="blur_2"/>\
        <feOffset dx="-1" dy="1" in="blur" result="offsetblur"/>\
        <feOffset dx="1" dy="-0.5" in="blur_2" result="offsetblur_w"/>\
         \
        <feComposite in="SourceAlpha" in2="offsetblur" operator="out" result="black_level"/>\
        <feComposite in="SourceAlpha" in2="offsetblur_w" operator="out" result="white_level"/>\
        <feComponentTransfer in="white_level" result="white_level">\
            <feFuncR type="table" tableValues="1 1"></feFuncR>\
            <feFuncG type="table" tableValues="1 1"></feFuncG>\
            <feFuncB type="table" tableValues="1 1"></feFuncB>\
            <feFuncA type="linear" slope="0.2"></feFuncA>\
        </feComponentTransfer>\
        \
        <feComponentTransfer in="black_level" result="black_level">\
            <feFuncA type="linear" slope="0.2"></feFuncA>\
        </feComponentTransfer>\
        \
        <feComponentTransfer data-type="color" result="shape" in="SourceAlpha">\
            <feFuncR type="table" tableValues="1 0"></feFuncR>\
            <feFuncG type="table" tableValues="0.8 0"></feFuncG>\
            <feFuncB type="table" tableValues="0.1 0"></feFuncB>\
            <feFuncA type="linear" slope="1"></feFuncA>\
        </feComponentTransfer>\
        <feMerge>\
            <feMergeNode in="shape"/>\
            <feMergeNode in="black_level"/>\
            <feMergeNode in="white_level"/>\
        </feMerge>';

        this.colorize = this.filter.container.querySelector('[data-type="color"]');
        this.update(this.options);
    };

    f.prototype.update = function (obj){
        var _mtrx;
        //console.warn('UPDATE IMPRESSION FX', obj);
        if(!obj['impression']){
            if(this.ele) this.removeFrom(this.ele);
        }else{
            if(this.ele) this.applyTo(this.ele);
            this.applyColor(obj['impression'].color, obj['impression'].type === 'impression' ? 0 : 1);
        }
    };

    f.prototype.applyColor = function(color, a){

        var r,g,b, m;
        if(!color) color = {'r': 255, 'g': 255, 'b': 255 };

        if(this.colorize){
            this.colorize.querySelector('feFuncR').setAttribute('tableValues', [ color.r / 255, 0].join(" "));
            this.colorize.querySelector('feFuncG').setAttribute('tableValues', [ color.g / 255, 0].join(" "));
            this.colorize.querySelector('feFuncB').setAttribute('tableValues', [ color.b / 255, 0].join(" "));
            this.colorize.querySelector('feFuncA').setAttribute('slope', a);
        }
    };

    this.ImpressionFilter = f;
}.call(this.GS.Filters));
